import dynamic from 'next/dynamic';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

export interface VideoRenderProps {
    title: string;
    youtubeVideoId?: string;
    url?: string;
}

const styles = {
    container: {
        paddingBottom: '56.25%', // 16/9 ratio
    },
};

export const VideoRender = (props: VideoRenderProps) => {
    const { title, youtubeVideoId, url } = props;

    const youtubeUrl = youtubeVideoId ? `https://www.youtube.com/embed/${youtubeVideoId}` : url;

    return (
        <div className="flex flex-col w-full mt-8 lg:mb-12">
            <div className="relative items-center w-full h-0 overflow-hidden" style={styles.container}>
                <ReactPlayer style={{ position: 'absolute' }} width="100%" height="100%" controls src={youtubeUrl} />
            </div>
            <span className="py-4 text-center text-gray-700">{title}</span>
        </div>
    );
};

export default VideoRender;
